import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Profilepage from '../../components/Profilepage'
import Scrollbar from '../../components/scrollbar'

const ProfilePage =() => {
    return(
        <Fragment>
            <Navbar/>
            <Profilepage/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ProfilePage;